import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT, validLicenceNumber } from '../../../constants/globalConstants'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { matchPassword, restrictInValidCharPassword, restrictSpecialChar, validateEmail, validatePassword, validatePhone } from '../../.././utils/helper'
import { getPassListDetail, getVehicleDataList } from '../../../redux/actions/passListAction'
import { getVehicleModelList } from '../../../redux/actions/VehicleListAction'
import { getFacilityList } from '../../../redux/actions/BasicInfoAction'
import Login from '../../../components/global/login'
import { Circles } from 'react-loader-spinner'
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
import './PassForm.scss'


function PassForm(props) {
    const { setPage, formData, setFormData, formError, dispatch, setMainVehicleMakeList } = props
    /// console.log('formData permit',props)
    const [isLoginModal, setLoginModal] = useState(false)
    const [caller, setCaller] = useState()
    const [resident, setResident] = useState()
    const [facilityList, setFacilityList] = useState(EMPTY_ARRAY)
    const [facilityPassList, setFacilityPassList] = useState(EMPTY_ARRAY)
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [zipcode, setZipcode] = useState('')
    const partner = window.location.toString().split('/')[3]



    // show and hide passowrd 
    const [cpasswordShown, setCPasswordShown] = useState(false)
    const [mpasswordShown, setMPasswordShown] = useState(false)

    const [loginData, setLoginData] = useState(EMPTY_OBJECT)
    const [showRemoveButton, setRemoveButtonShowKey] = useState('')

    // vehicle
    const [isVehicleTableVisible, setIsVehicleTableVisible] = useState(false)
    const [vehicleList, setVehicleList] = useState(EMPTY_ARRAY)
    const [vehicleDetailsList, setVehicleDetailsList] = useState(EMPTY_ARRAY)
    const [vehicleMakeList, setVehicleMakeList] = useState(EMPTY_ARRAY)
    const [vehicleModelList, setvehicleModelList] = useState(EMPTY_ARRAY)

    useEffect(() => {
        dispatch(getFacilityList(partner)).then((res) => {
            setFacilityList(res)
            if (formData?.facility_id) {
                const selFaclity = res?.filter((item) => item?.id == Number(formData?.facility_id))
                if (selFaclity[0] && selFaclity[0]?.full_name != '') {
                    localStorage.setItem('facility', JSON.stringify(selFaclity[0]))
                    dispatch(getPassListDetail(formData?.facility_id)).then((res) => {
                        if (res) {
                            setFacilityPassList(res)
                        }
                    })
                }
            }
        })
    }, [EMPTY_ARRAY])

    useEffect(() => {
        setPage('home')
        const vehicles = formData?.vehicleList
        const getuserDatafromLocal = JSON.parse(localStorage.getItem('userData'))
        setLoginData(getuserDatafromLocal?.user)
        if (getuserDatafromLocal?.access_token && getuserDatafromLocal?.access_token != '') {
            const signupFormData = JSON.parse(localStorage.getItem('userData'))

            if ((vehicles?.length > 0 && vehicles[0]?.license_plate != '') && !formData?.vehicleSelected) {
                setIsVehicleTableVisible(false)
            } else {
                setIsVehicleTableVisible(true)
            }

            dispatch(getVehicleDataList()).then((res) => {
                setVehicleList(res?.data)
                if (res?.data?.length > 0) {
                    setIsVehicleTableVisible(false)
                } else {
                    setIsVehicleTableVisible(true)
                }
            })


            setIsLoggedIn(true)
            if (Object.values(signupFormData?.user)?.length > 0) {
                let userNameData = getuserDatafromLocal?.user?.name.split(' ')
                const loggedInUserData = signupFormData?.user
                formData['firstname'] = loggedInUserData?.name ? userNameData[0] : formData?.first_name
                formData['lastname'] = loggedInUserData?.name ? userNameData[1] : formData?.last_name
                // formData['firstname'] = loggedInUserData?.first_name ? loggedInUserData?.first_name : formData?.first_name
                // formData['lastname'] = loggedInUserData?.last_name ? loggedInUserData?.last_name : formData?.last_name
                formData['license_number'] = loggedInUserData?.license_number ? loggedInUserData?.license_number : formData?.license_number
                formData['email'] = loggedInUserData?.email ? loggedInUserData?.email : formData?.email
                formData['phone'] = loggedInUserData?.phone_number ? loggedInUserData?.phone_number : formData?.phone
                formData['address'] = loggedInUserData?.address ? loggedInUserData?.address : formData?.address
                formData['address2'] = loggedInUserData?.address2 ? loggedInUserData?.address2 : formData?.address2
                formData['city'] = loggedInUserData?.city ? loggedInUserData?.city : formData?.city
                formData['state'] = loggedInUserData?.state ? loggedInUserData?.state : formData?.state
                formData['zipcode'] = loggedInUserData?.zipcode ? loggedInUserData?.zipcode : formData?.zipcode
                setFormData({ ...formData })
            }
        } else {
            setIsLoggedIn(false)
            setFormData({ ...formData })
            setIsVehicleTableVisible(true)
        }
        getVehical()

    }, [EMPTY_ARRAY])

    const getVehical = () => {
        dispatch(getVehicleModelList()).then((res) => {
            let makeList = res.make
            makeList.unshift({
                'id': 'Others',
                'name': 'Others',
                'mst_model': [{
                    'id': 'Others',
                    'make_id': 'Others',
                    'name': 'Others'
                }]
            })

            setVehicleMakeList(makeList)
            setMainVehicleMakeList(makeList)
            setVehicleDetailsList(res)
            // setValue('country', res.country[0].name)
            // if (BookingEdit) {
            // 	let model = (res?.make?.length > 0) && res?.make?.filter((v) => v?.name == BookingEditData?.vehical_details?.make)
            // 	setvehicleModelList(model[0]?.mst_model)
            // }

        })

    }

    const handleLicenceNumberChange = (e) => {
        const { value } = e.target
        if (value?.length > 6 && value?.length < 14) {
            if (value?.length != 9) {
                if (validLicenceNumber.test(value?.trim())) {
                    const licenseData = {
                        resident: 'Non-Resident',
                        license_number: value?.toUpperCase()
                    }
                    setResident('Non-Resident')
                    setFormData({ ...formData, ...licenseData })
                } else {
                    const licenseData = {
                        resident: '',
                        license_number: value?.toUpperCase()
                    }
                    setFormData({ ...formData, ...licenseData })
                    setResident('Invalid License Number')
                }
            } else {
                const alpha = value?.slice(0, 1)
                const number = value?.slice(1, 9)
                if (/^[a-zA-Z]+$/.test(alpha) && /(\d{8})/g.test(number)) {
                    const licenseData = {
                        resident: 'Resident',
                        license_number: value?.toUpperCase()
                    }
                    setFormData({ ...formData, ...licenseData })
                    setResident('Resident')
                } else {
                    if (validLicenceNumber.test(value?.trim())) {
                        const licenseData = {
                            resident: 'Non-Resident',
                            license_number: value?.toUpperCase()
                        }
                        setFormData({ ...formData, ...licenseData })
                        setResident('Non-Resident')
                    } else {
                        const licenseData = {
                            resident: '',
                            license_number: value?.toUpperCase()
                        }
                        setFormData({ ...formData, ...licenseData })
                        setResident('Invalid License Number')
                    }
                }
            }
        } else {
            const licenseData = {
                resident: '',
                license_number: value?.toUpperCase()
            }
            setFormData({ ...formData, ...licenseData })
            setResident('')
        }
    }

    const handleInputFieldsData = (e, i) => {
        const { name, value } = e.target
        const payloadData = { ...formData }
        if (name == 'color') {
            let colorData = vehicleDetailsList?.color?.filter((v) => v.name == value)
            payloadData.vehicleList[i]['color'] = colorData?.[0]?.name
            payloadData.vehicleList[i]['color_id'] = colorData?.[0]?.id
            setFormData({ ...payloadData })
        } else if (name === 'license_plate' || name == 'modeltext' || name == 'maketext' || name == 'state_id') {
            payloadData.vehicleList[i][name] = value
            setFormData({ ...payloadData })
        } else if (name === 'facility_id') {
            if (value) {
                dispatch(getPassListDetail(value)).then((res) => {
                    if (res) {
                        setFacilityPassList(res)
                    }
                })
            } else {
                setFacilityPassList([])
            }
            setFormData({ ...formData, 'facility_id': value })
        } else if (name == 'model') {
            payloadData.vehicleList[i]['othermodel'] = (value == 'Others') ? true : false
            payloadData.vehicleList[i][name] = value
            let modelData = vehicleModelList?.filter((v) => v.name == value)
            payloadData.vehicleList[i]['model_id'] = modelData?.[0]?.id != 'Others' ? modelData?.[0]?.id : ''
            payloadData.vehicleList[i]['modeltext'] = value == 'Others' ? '' : value
            setFormData({ ...payloadData })
        } else if (name == 'make') {
            let modelData = vehicleDetailsList?.make?.filter((v) => v.name == value)
            let modelList = modelData[0].mst_model
            let makeData = vehicleMakeList?.filter((v) => v?.name == value)
            let check = modelList?.some((value) => value?.name == 'Others')
            if (!check) {
                modelList.unshift({
                    'id': 'Others',
                    'make_id': 'Others',
                    'name': 'Others'
                })
            } else {
                // If 'Others' exists, find and move it to the first index
                modelList = modelList.filter((value) => value?.name !== 'Others') // Remove 'Others' from the list
                modelList.unshift({
                    'id': 'Others',
                    'make_id': 'Others',
                    'name': 'Others'
                }) // Add it back at the first index
            }
            setvehicleModelList(modelList)
            //   setVehicleMakeID(value)
            payloadData.vehicleList[i]['model_id'] = ''
            payloadData.vehicleList[i]['model'] = value == 'Others' ? 'Others' : ''
            payloadData.vehicleList[i]['modeltext'] = ''
            payloadData.vehicleList[i]['vehicleList'] = modelList
            // setVehicleList([...vehicleList])
            payloadData.vehicleList[i]['make_id'] = makeData?.[0]?.id != 'Others' ? makeData?.[0]?.id : ''
            payloadData.vehicleList[i][name] = value?.replace(/[^a-zA-Z0-9]/g, '')
            payloadData.vehicleList[i]['maketext'] = value == 'Others' ? '' : value?.replace(/[^a-zA-Z0-9]/g, '')
            payloadData.vehicleList[i]['othermake'] = (value == 'Others') ? true : false
            payloadData.vehicleList[i]['othermodel'] = (value == 'Others') ? true : false
            setFormData({ ...payloadData })
        } else if (name === 'pass_id') {
            const setPassDetails = facilityPassList?.filter((item) => item?.id == Number(value))
            if (setPassDetails[0] && setPassDetails[0]?.description != '') {
                localStorage.setItem('passDetails', JSON.stringify(setPassDetails[0]))
            }
            setFormData({ ...formData, 'pass_id': value })
        } if (name === 'zipcode') {
            let str = value
            let pattern = /\d/
            if (value && value != '') {
                str.match(pattern) ? setZipcode('') : setZipcode('The zipcode should contain at least a number.')
            }
            setFormData({ ...formData, 'zipcode': value })

        } else {
            setFormData({ ...formData, [name]: value })
        }
    }

    const handlePhoneChange = (value) => {
        setFormData({ ...formData, ['phone']: value })
    }

    const handleModalOpen = () => {
        setLoginModal(true)
        setCaller('home')
    }

    const handleVehicleChange = (e) => {
        const { value } = e.target
        if (value != '') {
            const selectedVehicle = vehicleList?.filter((vehicle) => vehicle?.license_plate_number == value)
            const payloadData = { ...formData }
            payloadData.vehicleList[0]['license_plate'] = selectedVehicle[0]?.license_plate_number
            payloadData.vehicleList[0]['make'] = selectedVehicle[0]?.make
            payloadData.vehicleList[0]['model'] = selectedVehicle[0]?.model
            payloadData.vehicleList[0]['color'] = selectedVehicle[0]?.color
            payloadData['vehicleSelected'] = true
            setFormData({ ...payloadData })
        } else {
            const payloadData = { ...formData }
            payloadData.vehicleList[0]['license_plate'] = ''
            payloadData.vehicleList[0]['make'] = ''
            payloadData.vehicleList[0]['model'] = ''
            payloadData.vehicleList[0]['color'] = ''
            payloadData['vehicleSelected'] = false

            setFormData({ ...payloadData })
        }

    }

    const showVehicleTable = () => {
        setIsVehicleTableVisible(true)

        setRemoveButtonShowKey()
        const payloadData = { ...formData }
        payloadData.vehicleList[0]['license_plate'] = ''
        payloadData.vehicleList[0]['make'] = ''
        payloadData.vehicleList[0]['model'] = ''
        payloadData.vehicleList[0]['color'] = ''
        payloadData.vehicleList[0]['state_id'] = ''
        payloadData.vehicleList[0]['vehicleList'] = ''
        payloadData.vehicleList[0]['othermake'] = ''
        payloadData.vehicleList[0]['othermodel'] = ''
        payloadData['vehicleSelected'] = false

        setFormData({ ...payloadData })
    }

    const removeVehicleMake = () => {
        setIsVehicleTableVisible(false)
        const payloadData = { ...formData }
        payloadData.vehicleList[0]['license_plate'] = ''
        payloadData.vehicleList[0]['make'] = ''
        payloadData.vehicleList[0]['model'] = ''
        payloadData.vehicleList[0]['color'] = ''
        payloadData.vehicleList[0]['state_id'] = ''
        payloadData.vehicleList[0]['othermake'] = ''
        payloadData.vehicleList[0]['othermodel'] = ''
        payloadData['vehicleSelected'] = false
        setFormData({ ...payloadData })
    }


    // show and hide password 
    const togglePasswordVisiblity = (e, key) => {
        if (key === 'password') {
            setMPasswordShown(mpasswordShown ? false : true)
        }
        if (key === 'cpassword') {
            setCPasswordShown(cpasswordShown ? false : true)
        }
    }


    return (
        <div >
            <h4 className="text-center my-4 mb-4">Account Information</h4>
            {!isLoggedIn && <div className="bg-white card p-3 mb-4">
                <p className="m-0">
                    <button type='button' className="btn btn-outline-primary" onClick={handleModalOpen} data-bs-target="#loginModal">LOG
                        IN</button> <strong> OR CREATE ACCOUNT BELOW</strong><br /><small
                            className="text-danger">*You must log in or create a new account to
                        proceed.</small>
                </p>
            </div>}
            <div className="mt-2">
                <div className="row g-2">
                    <div className="col-sm-6">
                        <div className="mb-3">
                            <label className="form-label">First Name <span className='text-danger'> *</span></label>
                            <input
                                className="form-control "
                                id="firstname" name="firstname" placeholder="First Name"
                                maxLength={20}
                                minLength={1}
                                disabled={isLoggedIn}
                                value={formData?.firstname ? formData?.firstname : ''}
                                onChange={(e) => handleInputFieldsData(e)}
                                autoComplete='none'
                                required="" type="text" />
                            <span className="form-text text-danger h-40">{formError == 'home' && !formData?.firstname ? 'This field is required' : ''}</span>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-3">

                            <label className="form-label">Last Name</label>
                            <input
                                maxLength={20}
                                disabled={(!loginData?.last_name) ? false : true}
                                minLength={1}
                                className="form-control "
                                name="lastname"
                                value={formData?.lastname ? formData?.lastname : ''} placeholder="Last Name"
                                required={!isLoggedIn}
                                type="text"
                                onChange={(e) => handleInputFieldsData(e)}
                                autoComplete='none' />
                            {/* <span className="form-text text-danger h-40">{!isLoggedIn && formError == 'home' && !formData?.lastname ? 'This field is required' : ''}</span> */}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-3">
                            <label className="form-label">Email <span className='text-danger'> *</span></label><input
                                className="form-control "
                                maxLength={40}
                                disabled={isLoggedIn}
                                minLength={1}
                                name="email" placeholder="Email" required="" type="email"
                                value={formData?.email ? formData?.email : ''}
                                onChange={(e) => handleInputFieldsData(e)}
                                autoComplete='none'
                                pattern="^[^@]+@[^@]+.[a-zA-Z]{2,6}" />
                            <span className="form-text text-danger h-40">{formError == 'home' ? !formData?.email ? 'This field is required' : !validateEmail(formData?.email) ? 'Please enter a valid email address' : '' : ''}</span>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-3">
                            <label className="form-label">Phone <span className='text-danger'> *</span></label>
                            <MaskedInput
                                maskGenerator={phoneMaskGenerator}
                                value={formData?.phone ? formData?.phone : ''}
                                type="text"
                                name="phone"
                                id="phone"
                                className="form-control"
                                disabled={isLoggedIn}
                                required
                                // pattern="[0-9 \\-\(\)\]{14}"
                                maxLength={14}
                                minLength={14}
                                title="Please enter a valid phone number"
                                onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                onInput={e => e.target.setCustomValidity('')}
                                placeholder="Phone Number"
                                onChange={handlePhoneChange}
                            />
                            <span className="form-text text-danger h-40">{formError == 'home' ? !formData?.phone ? 'This field is required' : !validatePhone(formData?.phone) ? 'Please enter a valid phone number' : '' : ''}</span>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-3">
                            <label className="form-label">Select Facility <span className='text-danger'> *</span></label>
                            <select name="facility_id" id="facility_id" className="form-select" onChange={(e) => handleInputFieldsData(e)} autoComplete='none' >
                                <option value=''>Select Facility</option>
                                {facilityList?.map((faclityListItem, faclityListIndex) => {
                                    return (
                                        <option value={faclityListItem?.id} selected={formData?.facility_id == faclityListItem?.id} key={faclityListIndex}>{faclityListItem?.full_name}</option>
                                    )
                                })}
                            </select>
                            <span className="form-text text-danger h-40">{formError == 'home' && !formData?.facility_id ? 'This field is required' : ''}</span>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-3">
                            <label className="form-label">Select Pass <span className='text-danger'> *</span></label>
                            <select name="pass_id" id="pass_id" className="form-select" onChange={(e) => handleInputFieldsData(e)} autoComplete='none' >
                                <option value=''>Select Pass</option>
                                {facilityPassList?.map((faclityListItem, faclityListIndex) => {
                                    return (
                                        <option value={faclityListItem?.id} selected={formData?.pass_id == faclityListItem?.id} key={faclityListIndex}>{faclityListItem?.description}</option>
                                    )
                                })}
                            </select>
                            <span className="form-text text-danger h-40">{formError == 'home' && !formData?.pass_id ? 'This field is required' : ''}</span>
                        </div>
                    </div>
                    {/* address */}

                    <div className="col-sm-6">
                        <div className="mb-3">
                            <label className="form-label">Address Line 1 </label>
                            <input
                                maxLength={100}
                                className="form-control "
                                name="address" placeholder="Address Line 1"
                                value={formData?.address ? formData?.address : ''}
                                onChange={handleInputFieldsData}
                                type="text" />
                            {/* <span className="form-text text-danger h-40">{formError == 'home' && !formData?.address ? 'This field is required' : ''}</span> */}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-3">
                            <label className="form-label">Address Line 2 </label><input
                                maxLength={100}
                                className="form-control ng-untouched ng-pristine ng-valid"
                                name="address2" placeholder="Address Line 2 (optional)"
                                value={formData?.address2 ? formData?.address2 : ''}
                                onChange={handleInputFieldsData}
                                type="text" /></div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-3">
                            <label className="form-label">City </label><input
                                maxLength={20}
                                className="form-control "
                                name="city" value={formData?.city ? formData?.city : ''} placeholder="City" type="text" onChange={handleInputFieldsData} />
                            {/* <span className="form-text text-danger h-40">{formError == 'home' && !formData?.city ? 'This field is required' : ''}</span> */}
                        </div>
                    </div>
                    <div className="col-sm-6 col-xs-6">
                        <div className="mb-3">
                            <label className="form-label">State </label><input
                                maxLength={20}
                                className="form-control "
                                name="state" placeholder="State"
                                value={formData?.state ? formData?.state : ''}
                                onChange={handleInputFieldsData}
                                type="text" />
                            {/* <span className="form-text text-danger h-40">{formError == 'home' && !formData?.state ? 'This field is required' : ''}</span> */}
                        </div>
                    </div>



                    {/* end */}
                    <div className="col-sm-6">
                        <div className="mb-3 position-relative">
                            <label className="form-label">Driver License Number <span className='text-danger'> * </span>
                                <span className="popoverSection position-relative"  >
                                    <span className='small popoverContent position-absolute shadow-sm bg-white p-2 border'>Driving License Number must contain first letter character and other numbers.</span>
                                    <i className="fa fa-info-circle " />
                                </span>
                            </label>
                            <input
                                className="form-control "
                                name="license_number"
                                id="license_number"
                                maxLength={13}
                                value={formData?.license_number}
                                minLength={1}
                                placeholder="License Number"
                                required=""
                                onKeyDown={restrictSpecialChar}
                                disabled={(!loginData?.license_number) ? false : true}
                                type="text"
                                onChange={(e) => handleLicenceNumberChange(e, 'change', formData?.facility_id)}
                            />
                            <span className='position-absolute end-0 top-100'>
                                {resident == 'checking...' ? <span><Circles
                                    height="15"
                                    width="15"
                                    color="var(--bs-primary)"
                                    ariaLabel="circles-loading"
                                    visible={true}
                                /></span> : <span className={resident == 'Invalid License Number' ? 'form-text text-danger h-40' : 'form-text text-primary h-40'}><b>{resident}</b></span>}
                            </span>
                            {/* <span className="form-text text-danger h-40">{formError == 'home' ? !formData?.license_number ? 'This field is required' : !validLicenceNumber.test(formData?.license_number?.trim()) ? 'Please enter a valid license number' : '' : ''}</span> */}
                            <span className="form-text text-danger h-40">{formError == 'home' && !formData?.license_number ? 'This field is required' : ''}</span>

                        </div>
                    </div>
                    <div className="col-sm-6 ">
                        <div className="mb-3">
                            <label className="form-label">Zipcode </label><input
                                className="form-control "
                                maxLength="6" minLength="5" name="zipcode"
                                value={formData?.zipcode ? formData?.zipcode : ''}
                                placeholder="Zip Code" type="text" onChange={handleInputFieldsData} />
                            <span className="form-text text-danger h-40">{zipcode}</span>
                            {/* <span className="form-text text-danger h-40">{formError == 'home' && !formData?.zipcode ? 'This field is required' : ''}{zipcode}</span> */}
                        </div>
                    </div>

                    <div className="clearfix">
                        <label className="form-label">Vehicle Information <span className='text-danger'> *</span></label>
                        {isLoggedIn &&
                            <div className='row '>
                                {vehicleList?.length > 0 && <div className="col-sm-6">
                                    <div className="mb-3">
                                        <select name="vehicle" id="vehicle" disabled={isVehicleTableVisible} className="form-select" onChange={handleVehicleChange} >
                                            <option value=''>Select Vehicle</option>
                                            {vehicleList?.map((vehicle, index) => {
                                                return (
                                                    <option value={vehicle?.license_plate_number} selected={vehicle?.license_plate_number == formData?.vehicleList[0]?.license_plate} key={index}>{vehicle?.license_plate_number}</option>
                                                )
                                            })}
                                        </select>
                                        <span className="form-text text-danger h-40">{formError == 'home' && !formData?.vehicleList?.[0]?.license_plate ? 'Please select or add new vehicle' : ''}</span>
                                    </div>
                                </div>}
                                <div className='col-sm-6 mb-3'>{vehicleList?.length > 0 && <span className='badge badge-primary text-dark fw-bold me-2'>OR</span>}  {vehicleList?.length > 0 && <button type='button' className='btn btn-primary' onClick={(e) => showVehicleTable(e)}><i className='fa fa-plus'></i> Add New vehicle</button>}</div>

                            </div>}
                        {(vehicleList?.length < 1 || isVehicleTableVisible) ? formData?.vehicleList?.map((vehicleListItem, vehicleListIndex) => {
                            return (
                                <div className='bg-light border p-2 mb-2 position-relative' key={vehicleListIndex}>
                                    <div className='row g-2 row-cols-2  row-cols-sm-3 row-cols-md-4' >

                                        <div className={'col'}>
                                            <label className='form-label' >License Plate <span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                name='license_plate'
                                                className="form-control"
                                                placeholder="License Plate"
                                                maxLength={10}
                                                minLength={1}
                                                onKeyDown={restrictSpecialChar}
                                                value={vehicleListItem?.license_plate}
                                                onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
                                                aria-describedby="licenseplate" />
                                            <span className="form-text text-danger h-40">{formError == 'home' && !formData?.vehicleList?.[vehicleListIndex]?.license_plate != '' ? 'This field is required' : ''}</span>
                                        </div>
                                        <div className={'col'}>
                                            <label className='form-label' > Vehicle Make </label>
                                            <select autoComplete="off" name="make" placeholder="Make" onKeyDown={restrictSpecialChar} className="form-select form-control" value={vehicleListItem?.make} id="make" onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}>
                                                <option value="">Select Make</option>
                                                {(vehicleMakeList?.length > 0) && vehicleMakeList?.map((val, index) => {
                                                    return (
                                                        <option value={val?.name} key={index} >{val?.name}</option>
                                                    )
                                                })}
                                            </select>
                                            {/* {vehicleListItem?.othermake ? <input
                                            type="text"
                                            name='maketext'
                                            label="Make"
                                            className="form-control"
                                            placeholder=""
                                            required={true}
                                            onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
                                            maxLength={15}
                                            minLength={0}
                                            onKeyDown={restrictSpecialChar}
                                            value={vehicleListItem?.maketext}
                                            aria-describedby="color" />
                                        : ''} */}


                                            {/* <span className="form-text text-danger h-40">{formError == 'home' && !formData?.vehicleList?.[vehicleListIndex]?.make != '' ? 'This field is required' : ''}</span> */}
                                        </div>
                                        {vehicleListItem?.othermake ? <div className={'col'}>
                                            <label className='form-label' >Make </label>
                                            <input
                                                type="text"
                                                name='maketext'
                                                label="Make"
                                                className="form-control"
                                                placeholder="Make"
                                                required={true}
                                                onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
                                                maxLength={15}
                                                minLength={0}
                                                onKeyDown={restrictSpecialChar}
                                                value={vehicleListItem?.maketext}
                                                aria-describedby="color" />



                                            {/* <span className="form-text text-danger h-40">{formError == 'home' && !formData?.vehicleList?.[vehicleListIndex]?.make != '' ? 'This field is required' : ''}</span> */}
                                        </div> : ''}



                                        {!vehicleListItem?.othermake ? <div className={'col'}>
                                            <label className='form-label' >Vehicle Model</label>
                                            <select className='form-select form-control' value={vehicleListItem?.model} placeholder="Model" name="model" id='state' onKeyDown={restrictSpecialChar} onChange={(e) => handleInputFieldsData(e, vehicleListIndex)} disabled={vehicleListItem.make ? false : true}>
                                                <option value="0">Select an option</option>

                                                {(vehicleListItem?.vehicleList.length > 0) && vehicleListItem?.vehicleList?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
                                            </select>
                                            {/* {(vehicleListItem?.othermake || vehicleListItem?.othermodel) ? <input
                                            type="text"
                                            name='modeltext'
                                            className="form-control"
                                            placeholder=""
                                            onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
                                            maxLength={15}
                                            minLength={4}
                                            onKeyDown={restrictSpecialChar}
                                            value={vehicleListItem?.modeltext}
                                            aria-describedby="model" /> : ''} */}
                                            {/* <span className="form-text text-danger h-40">{formError == 'home' && !formData?.vehicleList?.[vehicleListIndex]?.make != '' ? 'This field is required' : ''}</span> */}
                                        </div> : ''}

                                        {(vehicleListItem?.othermake || vehicleListItem?.othermodel) ? <div className={'col'}>
                                            <label className='form-label' >Model</label>
                                            <input
                                                type="text"
                                                name='modeltext'
                                                className="form-control"
                                                placeholder="Model"
                                                onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
                                                maxLength={15}
                                                minLength={4}
                                                onKeyDown={restrictSpecialChar}
                                                value={vehicleListItem?.modeltext}
                                                aria-describedby="model" />
                                            {/* <span className="form-text text-danger h-40">{formError == 'home' && !formData?.vehicleList?.[vehicleListIndex]?.make != '' ? 'This field is required' : ''}</span> */}
                                        </div> : ''}

                                        <div className={'col'}>
                                            <label className='form-label' >Color </label>
                                            <select name='color' autoComplete="off" className='form-select form-control' value={vehicleListItem?.color} placeholder="Color" id='color' onChange={(e) => handleInputFieldsData(e, vehicleListIndex)} onKeyDown={restrictSpecialChar}>
                                                <option value="0">Select an option</option>
                                                {(vehicleDetailsList?.color?.length > 0) && vehicleDetailsList?.color?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
                                            </select>
                                            {/* <input
                                            type="text"
                                            name='model'
                                            className="form-control"
                                            placeholder="Model"
                                            onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
                                            maxLength={15}
                                            minLength={4}
                                            onKeyDown={restrictSpecialChar}
                                            value={vehicleListItem?.model}
                                            aria-describedby="Model" /> */}
                                            {/* <span className="form-text text-danger h-40">{formError == 'home' && !formData?.vehicleList?.[vehicleListIndex]?.model != '' ? 'This field is required' : ''}</span> */}
                                        </div>
                                        <div className={'col'}>
                                            <label className='form-label' >State/Province</label>
                                            <select className='form-select form-control' value={vehicleListItem?.state_id} placeholder="Model" name="state_id" id='state_id' onKeyDown={restrictSpecialChar} onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}>
                                                <option value="0">Select an option</option>
                                                {(vehicleDetailsList?.state?.length > 0) && vehicleDetailsList?.state?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.id}>{item?.state_code}</option>)}
                                            </select>
                                            {/* <input
                                            type="text"
                                            name='model'
                                            className="form-control"
                                            placeholder="Model"
                                            onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
                                            maxLength={15}
                                            minLength={4}
                                            onKeyDown={restrictSpecialChar}
                                            value={vehicleListItem?.model}
                                            aria-describedby="Model" /> */}
                                            {/* <span className="form-text text-danger h-40">{formError == 'home' && !formData?.vehicleList?.[vehicleListIndex]?.model != '' ? 'This field is required' : ''}</span> */}
                                        </div>

                                        {/* {(vehicleList?.length > 0 && isLoggedIn()) ?<div className='col-sm col-2 mb-2'>
                                                    <button type="button" className="btn btn-danger w-100" onClick={() => removeVehicleMake()}><i className='fa fa-minus'></i></button> 
                                            </div>: null} */}


                                    </div>
                                    {(formData?.vehicleList?.length === vehicleListIndex) ?
                                        <div className='position-absolute top-0 right-0' >
                                            {/* <button className='btn btn-primary w-100' disabled={formData?.vehicleList?.length > 2} onClick={addVehicle}><i className='fa fa-plus'></i></button> */}
                                            {(showRemoveButton) ? <button type="button" className="btn btn-danger btn-sm" onClick={(e) => removeVehicleMake(e, vehicleListIndex)}><i className='fa fa-minus'></i></button> : null}
                                        </div> : (!(formData?.vehicleList.length == 1) && vehicleListIndex !== -1) ?

                                            <div className='position-absolute top-0 right-0' ><button type="button" className="btn btn-danger btn-sm" onClick={(e) => removeVehicleMake(e, vehicleListIndex)}><i className='fa fa-minus'></i></button>

                                            </div> : null}
                                </div>
                            )
                        }) : ''}
                    </div>
                    {!isLoggedIn && <div className=" mt-2 ">
                        <p className="fw-bold mt-3 mb-2"  >
                            <span >Create Account Password <i className='text-danger' > * </i>
                                <span className="popoverSection position-relative"  >
                                    <span className='small popoverContent position-absolute shadow-sm bg-white p-2 border'>Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-). </span>
                                    <i className="fa fa-info-circle " />
                                </span>
                            </span>
                        </p>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="mb-3">
                                    <input
                                        maxLength={15}
                                        minLength={8}
                                        className="form-control "
                                        name="password"
                                        placeholder="Create Password"
                                        required=""
                                        value={formData?.password}
                                        onChange={(e) => setFormData({ ...formData, ['password']: restrictInValidCharPassword(e.target.value) })}
                                        autoComplete="off"
                                        // reverse="true"
                                        type={(!mpasswordShown) ? 'password' : 'text'}
                                    // validateequal="cpassword"
                                    />
                                    <i className={(!mpasswordShown) ? 'fas fa-eye-slash miconClass dd' : 'fas fa-eye miconClass'} onClick={(e) => togglePasswordVisiblity(e, 'password')}></i>
                                    <span className="form-text text-danger h-40">{formError == 'home' ? !formData?.password ? 'This field is required' : !validatePassword(formData?.password) ? 'Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-).' : !matchPassword(formData?.password, formData?.cpassword) ? 'Passwords does not match' : '' : ''}</span>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="mb-3">
                                    <input
                                        maxLength={15}
                                        minLength={8}
                                        className="form-control "
                                        value={formData?.cpassword}
                                        name="cpassword"
                                        placeholder="Confirm Password"
                                        required=""
                                        onChange={(e) => setFormData({ ...formData, ['cpassword']: restrictInValidCharPassword(e.target.value) })}
                                        autoComplete='none'
                                        type={(!cpasswordShown) ? 'password' : 'text'}
                                    // validateequal="password"
                                    />
                                    <i className={(!cpasswordShown) ? 'fas fa-eye-slash ciconClass' : 'fas fa-eye ciconClass'} onClick={(e) => togglePasswordVisiblity(e, 'cpassword')}></i>
                                    <span className="form-text text-danger h-40">{formError == 'home' ? !formData?.cpassword ? 'This field is required' : !validatePassword(formData?.cpassword) ? 'Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-).' : !matchPassword(formData?.password, formData?.cpassword) ? 'Passwords does not match' : '' : ''}</span>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
            <Login isLoginModal={isLoginModal} setLoginModal={setLoginModal} caller={caller} />
        </div>
    )
}

PassForm.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    setPage: PropTypes.func,
    formData: PropTypes.object,
    setFormData: PropTypes.func,
    formError: PropTypes.string,
    facilityPassList: PropTypes.array,
    facilityList: PropTypes.array,
    setMainVehicleMakeList: PropTypes.func
}

PassForm.defaulProps = {
    dispatch: noop,
    loader: PropTypes.bool,
    setPage: noop,
    formData: EMPTY_OBJECT,
    setFormData: noop,
    formError: '',
    setMainVehicleMakeList: noop
}


function mapStateToProps() {
    return {

    }

}
export default connect(mapStateToProps)(PassForm)
